import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

import { createContext } from './createContext';
import { sendWebviewInitAction } from './sendWebviewAction';

export function runApp(): void {
  const context = createContext();

  const store = createApplicationState(context);

  renderApplication({ context, store });

  sendWebviewInitAction(context.config);
}
